import React from 'react';
import { pluralize } from '../../utils';
import { Title, Subtitle } from 'scy/text';
import margin from 'scy/margin.mod.scss';

export default function SearchResultsHeader({ query, count, loading }) {
  return (
    <div className={`${margin.left_sm} ${margin.right_sm}`}>
      <Title tag="h1">Results for {query}</Title>
      {!loading && (
        <Subtitle tag="h2" marginClass={`${margin.top_0} ${margin.bottom_sm}`}>
          We found {count} {pluralize('result', count)}
        </Subtitle>
      )}
    </div>
  );
}
